import React, { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";
import bg from "../SYSADMIN/MathsDoctor/Images/top_blue_panel.png";
import Loading from "../Common/Loading";
import AnsCorrect from "../SYSADMIN/MathsDoctor/Images/AnsCorrect.GIF";
import AnsShouldbe from "../SYSADMIN/MathsDoctor/Images/AnsShouldbe.GIF";
import AnsWrong from "../SYSADMIN/MathsDoctor/Images/AnsWrong.GIF";
import large_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_n.png";
import large_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_d.png";
import medium_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_n.png";
import medium_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_d.png";
import small_objective_n from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_n.png";
import small_objective_d from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_d.png";
import large_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_shortened_n.png";
import large_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/large_objective_shortened_d.png";
import medium_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_shortened_n.png";
import medium_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/medium_objective_shortened_d.png";
import small_objective_shortened_n from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_shortened_n.png";
import small_objective_shortened_d from "../SYSADMIN/MathsDoctor/Images/Tablet/small_objective_shortened_d.png";
import zero_n from "../SYSADMIN/MathsDoctor/Images/Tablet/0_n.png";
import one_n from "../SYSADMIN/MathsDoctor/Images/Tablet/1_n.png";
import two_n from "../SYSADMIN/MathsDoctor/Images/Tablet/2_n.png";
import three_n from "../SYSADMIN/MathsDoctor/Images/Tablet/3_n.png";
import four_n from "../SYSADMIN/MathsDoctor/Images/Tablet/4_n.png";
import five_n from "../SYSADMIN/MathsDoctor/Images/Tablet/5_n.png";
import six_n from "../SYSADMIN/MathsDoctor/Images/Tablet/6_n.png";
import seven_n from "../SYSADMIN/MathsDoctor/Images/Tablet/7_n.png";
import eight_n from "../SYSADMIN/MathsDoctor/Images/Tablet/8_n.png";
import nine_n from "../SYSADMIN/MathsDoctor/Images/Tablet/9_n.png";
import backspace_n from "../SYSADMIN/MathsDoctor/Images/Tablet/backspace_n.png";
import decimal_n from "../SYSADMIN/MathsDoctor/Images/Tablet/decimal_n.png";
import plus_n from "../SYSADMIN/MathsDoctor/Images/Tablet/plus_n.png";
import minus_n from "../SYSADMIN/MathsDoctor/Images/Tablet/minus_n.png";


const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

async function apiFetch<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status} – ${url}`);
  return res.json() as Promise<T>;
}

interface CountryOption {
  value: string;
  text: string;
}

interface QuestionData {
  qn_file_url: string;
  qn_html?: string;
  qn_catg: string;
  lesson_code: string;
  fname: string;
  strand: number;
  substrand: number;
  year: number;
  topic: number;
  qn_no: number;
  country: string;
  curriculum: string;
  strand_label: string;
  substrand_label: string;
  topic_label: string;
  virtual_keypad: string;
  show_filter: boolean;
  show_nav: boolean;
  show_wrong_ans: boolean;
  qn_info?: string;
  correct_ans?: string;
  wrong_ans?: string;
  blank_ans?: string;
  opt_order?: string;
  EnteredCorrectAnswer?: string;
  EnteredWrongAnswer?: string;
  CorrectAnswer?: string;
  UserAnswer?: string;
  original_answer_from_html?: string;
  user_answer_provided?: string;
  is_answer_correct?: boolean;
  answer_status?: string;
  warning?: string;
}

interface QuestionStub {
  strand: number;
  substrand: number;
  yr: number;
  topic: number;
  qn_no: number;
  country: string;
  qn_catg: string;
  lesson_code: string;
  fname: string;
  qn_html?: string;
  correct_ans?: string;
  wrong_ans?: string;
  opt_order?: string;
  blank_ans?: string;
  EnteredCorrectAnswer?: string;
  EnteredWrongAnswer?: string;
  CorrectAnswer?: string;
  UserAnswer?: string;
  original_answer_from_html?: string;
  user_answer_provided?: string;
  is_answer_correct?: boolean;
  answer_status?: string;
}

interface PageState {
  loading: boolean;
  overlayVisible: boolean;
  countries: CountryOption[];
  selectedCountry: string;
  selectedYear: string;
  strand: string;
  substrand: string;
  topic: string;
  qnType: string;
  current: QuestionData | null;
  questions: QuestionStub[];
  currentIndex: number;
  total: number;
  iframeReady: boolean;
  checkResult: string | null;
  warningMsg: string;
  showFilter: boolean;
  showNav: boolean;
  showWrongAns: boolean;
  isReportMode: boolean;
  reviewEnteredAnswer: string;
  reviewCorrectAnswer: string;
  reviewOriginalAnswer: string;
  didCheck: boolean;
  qnHtmlOverride: string;
}

type Action =
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "OVERLAY_HIDE" }
  | { type: "SET_COUNTRIES"; payload: CountryOption[] }
  | { type: "SET_FIELD"; field: keyof PageState; value: string }
  | { type: "SET_SEARCH_RESULT"; questions: QuestionStub[]; current: QuestionData }
  | { type: "SET_CURRENT"; current: QuestionData; index: number }
  | { type: "IFRAME_READY" }
  | { type: "CHECK_RESULT"; payload: string | null }
  | { type: "CHECK_CLICKED" }
  | { type: "SET_QN_HTML_OVERRIDE"; payload: string }
  | { type: "SET_REVIEW_ANSWERS"; entered: string; correct: string }
  | { type: "SET_ORIGINAL_ANSWER"; payload: string }
  | { type: "SET_WARNING"; payload: string }
  | { type: "SET_REPORT_MODE"; questions: QuestionStub[]; current: QuestionData };

function reducer(state: PageState, action: Action): PageState {
  switch (action.type) {
    case "SET_LOADING": return { ...state, loading: action.payload };
    case "OVERLAY_HIDE": return { ...state, overlayVisible: false };
    case "SET_COUNTRIES": return { ...state, countries: action.payload };
    case "SET_FIELD": return { ...state, [action.field]: action.value } as PageState;
    case "SET_SEARCH_RESULT":
      return {
        ...state,
        questions: action.questions, current: action.current,
        currentIndex: 0, total: action.questions.length,
        showFilter: action.current.show_filter, showNav: action.current.show_nav,
        showWrongAns: action.current.show_wrong_ans,
        iframeReady: false, checkResult: null,
        reviewEnteredAnswer: "", reviewCorrectAnswer: "", reviewOriginalAnswer: "",
        qnHtmlOverride: "", loading: true,
      };
    case "SET_CURRENT":
      return {
        ...state, current: action.current, currentIndex: action.index,
        iframeReady: false, checkResult: null,
        reviewEnteredAnswer: "", reviewCorrectAnswer: "", reviewOriginalAnswer: "",
        qnHtmlOverride: "", loading: true,
      };
    case "IFRAME_READY": return { ...state, iframeReady: true, loading: false };
    case "CHECK_RESULT": return { ...state, checkResult: action.payload };
    case "CHECK_CLICKED": return { ...state, didCheck: true };
    case "SET_QN_HTML_OVERRIDE": return { ...state, qnHtmlOverride: action.payload };
    case "SET_REVIEW_ANSWERS": return { ...state, reviewEnteredAnswer: action.entered, reviewCorrectAnswer: action.correct };
    case "SET_ORIGINAL_ANSWER": return { ...state, reviewOriginalAnswer: action.payload };
    case "SET_WARNING": return { ...state, warningMsg: action.payload, loading: false };
    case "SET_REPORT_MODE":
      return {
        ...state,
        questions: action.questions, current: action.current,
        currentIndex: 0, total: action.questions.length,
        showFilter: false, showNav: true, showWrongAns: true, isReportMode: true,
        reviewEnteredAnswer: "", reviewCorrectAnswer: "", reviewOriginalAnswer: "",
        qnHtmlOverride: "", loading: false,
      };
    default: return state;
  }
}

const initialState: PageState = {
  loading: false, overlayVisible: true, countries: [],
  selectedCountry: "", selectedYear: "ALL",
  strand: "", substrand: "", topic: "", qnType: "ALL",
  current: null, questions: [], currentIndex: 0, total: 0,
  iframeReady: false, checkResult: null, warningMsg: "",
  showFilter: true, showNav: false, showWrongAns: false, isReportMode: false,
  reviewEnteredAnswer: "", reviewCorrectAnswer: "", reviewOriginalAnswer: "",
  didCheck: false, qnHtmlOverride: "",
};

// ─────────────────────────────────────────────────────────────────────────────
// VIRTUAL NUMPAD COMPONENT  (display-only, no interaction — inputs are in iframe)
// ─────────────────────────────────────────────────────────────────────────────

interface VirtualNumpadProps { visible: boolean; }

const VirtualNumpad: React.FC<VirtualNumpadProps> = ({ visible }) => {
  if (!visible) return null;

  const KEY_IMAGES: { key: string; img: string; label: string }[] = [
    { key: "7", img: seven_n, label: "7" }, { key: "8", img: eight_n, label: "8" },
    { key: "9", img: nine_n, label: "9" }, { key: "4", img: four_n, label: "4" },
    { key: "5", img: five_n, label: "5" }, { key: "6", img: six_n, label: "6" },
    { key: "1", img: one_n, label: "1" }, { key: "2", img: two_n, label: "2" },
    { key: "3", img: three_n, label: "3" }, { key: "−", img: minus_n, label: "−" },
    { key: "0", img: zero_n, label: "0" }, { key: ".", img: decimal_n, label: "." },
    { key: "BACKSPACE", img: backspace_n, label: "⌫" }, { key: "+", img: plus_n, label: "+" },
  ];

  return (
    <div style={{
      position: "absolute" as const, bottom: 12, right: 12, zIndex: 1000,
      backgroundColor: "transparent", userSelect: "none" as const,
      pointerEvents: "none" as const
    }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, auto)", gap: 2 }}>
        {KEY_IMAGES.map(({ key, img, label }) => (
          <div key={key} style={{ lineHeight: 0 }}>
            <img src={img} alt={label} draggable={false}
              style={{ display: "block", width: 48, height: 48, objectFit: "contain" as const }} />
          </div>
        ))}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SHARED HELPERS
// ─────────────────────────────────────────────────────────────────────────────

const getDocValue = (doc: Document, id: string) => {
  const el = doc.getElementById(id) as HTMLInputElement | HTMLTextAreaElement | null;
  return (el?.value ?? "").trim();
};

// ─────────────────────────────────────────────────────────────────────────────
// SHARED OPTION-IMAGE HELPERS  (Type O and Type C)
// ─────────────────────────────────────────────────────────────────────────────

const getOptionImageType = (html: string): number => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const mwInfo = (doc.getElementById("KSD_MW_Info") as HTMLInputElement | null)?.value ?? "";
    return parseInt(mwInfo.split("|")[8] ?? "0", 10) || 0;
  } catch { return 0; }
};

const getOptionImages = (type: number): { normal: string; selected: string } | null => {
  switch (type) {
    case 2: return { normal: large_objective_n, selected: large_objective_d };
    case 3: return { normal: medium_objective_n, selected: medium_objective_d };
    case 4: return { normal: small_objective_n, selected: small_objective_d };
    case 5: return { normal: large_objective_shortened_n, selected: large_objective_shortened_d };
    case 6: return { normal: medium_objective_shortened_n, selected: medium_objective_shortened_d };
    case 7: return { normal: small_objective_shortened_n, selected: small_objective_shortened_d };
    default: return null;
  }
};

const hasImageOptions = (html: string): boolean => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  for (const cell of doc.querySelectorAll('[id^="KSD_TD_"]')) {
    if (cell.querySelector("img")) return true;
  }
  return false;
};

// ─────────────────────────────────────────────────────────────────────────────
// BASE CSS INJECTOR  (initial render skeleton for all types)
// ─────────────────────────────────────────────────────────────────────────────

const injectBaseCSS = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const optionType = getOptionImageType(html);
  const imgConfig = getOptionImages(optionType);
  const style = doc.createElement("style");
  style.textContent = `
    [id^="KSD_TR_"] [id^="KSD_TD_"] {
      ${imgConfig
      ? `background-image: url(${imgConfig.normal}); background-repeat: no-repeat; background-color: transparent;`
      : `background-color: #F8F8F8;`}
      cursor: pointer;
      padding-top: 5px !important;
      padding-bottom: 5px !important;
    }
    [id^="KSD_TD_"] tbody > tr > td { font-size: 0px !important; }
  `;
  doc.head.appendChild(style);
  return doc.documentElement.outerHTML;
};

const hideElementsByIdInHtml = (html: string, ids: string[]): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  ids.forEach(id => {
    const el = doc.getElementById(id);
    if (el) el.style.display = "none";
  });
  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// TYPE O — Single-select objective
// Isolated: only called when qn_catg === "O"
// ─────────────────────────────────────────────────────────────────────────────

const injectTypeO = (
  html: string,
  enteredCorrectAnswer?: string,
  enteredWrongAnswer?: string,
  correctAnswerIndex?: string,
  optOrder?: string
): string => {

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const optionType = getOptionImageType(html);
  const imgConfig = getOptionImages(optionType);

  // =========================================================
  // RESTORE STUDENT OPTION ORDER
  // =========================================================

  if (optOrder && optOrder.trim()) {

    const order = optOrder
      .split("~")
      .map(v => parseInt(v.trim(), 10))
      .filter(v => !Number.isNaN(v));

    if (order.length > 0) {

      const tbody = doc.querySelector("#KSD_TABLE > tbody");

      if (tbody) {

        const rowMap = new Map<number, Element>();

        tbody.querySelectorAll("tr[id^='KSD_TR_']").forEach(tr => {

          const id = tr.getAttribute("id") ?? "";

          const match = id.match(/^KSD_TR_(\d+)$/);

          if (match) {

            const originalIndex = parseInt(match[1], 10);

            if (!Number.isNaN(originalIndex)) {
              rowMap.set(originalIndex, tr);
            }
          }
        });

        // Remove current order
        rowMap.forEach(tr => {
          tr.parentNode?.removeChild(tr);
        });

        // Restore student's order
        order.forEach(originalIndex => {

          const row = rowMap.get(originalIndex);

          if (row) {
            tbody.appendChild(row);
          }
        });
      }
    }
  }

  // =========================================================
  // STYLING
  // =========================================================

  const style = doc.createElement("style");

  style.textContent = `
    [id^="KSD_TR_"] [id^="KSD_TD_"] {
      ${
        imgConfig
          ? `
            background-image: url(${imgConfig.normal});
            background-repeat: no-repeat;
            background-color: transparent;
          `
          : `
            background-color: #F8F8F8;
          `
      }

      cursor: default;
      padding-top: 5px !important;
      padding-bottom: 5px !important;
    }

    [id^="KSD_TD_"] tbody > tr > td {
      font-size: 0px !important;
    }
  `;

  doc.head.appendChild(style);

  // =========================================================
  // ANSWER MARKING
  // =========================================================

  const correctIdx = parseInt(
    (enteredCorrectAnswer ?? "").trim(),
    10
  );

  const wrongIdx = parseInt(
    (enteredWrongAnswer ?? "").trim(),
    10
  );

  const hasCorrect = !Number.isNaN(correctIdx);
  const hasWrong = !Number.isNaN(wrongIdx);

  doc.querySelectorAll('tr[id^="KSD_TR_"]').forEach(tr => {

    const rowId = tr.getAttribute("id") ?? "";

    const match = rowId.match(/^KSD_TR_(\d+)$/);

    if (!match) return;

    const originalIdx = parseInt(match[1], 10);

    if (Number.isNaN(originalIdx)) return;

    const ansTd =
      tr.querySelector('td[id^="KSD_TDANS_"]') ??
      tr.querySelector('td[id^="TDANS_"]');

    if (!ansTd) {
      console.log(
        "[Type O] Answer cell not found:",
        rowId
      );
      return;
    }

    ansTd.querySelectorAll("img").forEach(img => img.remove());

    (ansTd as HTMLElement).style.display = "";

    // WRONG STUDENT ANSWER
    if (hasWrong && originalIdx === wrongIdx) {

      const img = doc.createElement("img");

      img.setAttribute("id", "imgR");
      img.src = AnsWrong;
      img.alt = "Incorrect Answer";
      img.style.verticalAlign = "middle";

      ansTd.appendChild(img);

      console.log(
        "[Type O] WRONG:",
        originalIdx,
        rowId
      );

      return;
    }

    // CORRECT ANSWER
    if (hasCorrect && originalIdx === correctIdx) {

      const img = doc.createElement("img");

      img.setAttribute("id", "imgR");

      if (hasWrong) {
        img.src = AnsShouldbe;
        img.alt = "Correct Answer";
      } else {
        img.src = AnsCorrect;
        img.alt = "Correct Answer";
      }

      img.style.verticalAlign = "middle";

      ansTd.appendChild(img);

      console.log(
        "[Type O] CORRECT:",
        originalIdx,
        rowId
      );
    }
  });

  return doc.documentElement.outerHTML;
};
// ─────────────────────────────────────────────────────────────────────────────
// TYPE C — Multi-select checkbox
// Isolated: only called when qn_catg === "C"
// Ported from EL_C.js: Init_C / ReInit_C / MarkAns_C
// ─────────────────────────────────────────────────────────────────────────────

const parseTypeCAnswerIndices = (
  enteredCorrectAnswer: string,
  enteredWrongAnswer: string
): { correctOriginalIndices: Set<number>; selectedCorrectIndices: Set<number>; selectedWrongIndices: Set<number> } => {
  const toNumSet = (raw: string): Set<number> => {
    const s = new Set<number>();
    if (!raw || !raw.trim()) return s;
    for (const token of raw.split("~").map(t => t.trim()).filter(Boolean)) {
      const n = parseInt(token, 10);
      if (!isNaN(n)) s.add(n);
    }
    return s;
  };
  const hashParts = (enteredCorrectAnswer ?? "").split("#");
  return {
    correctOriginalIndices: toNumSet(hashParts[0] ?? ""),
    selectedCorrectIndices: toNumSet(hashParts[1] ?? ""),
    selectedWrongIndices: toNumSet(enteredWrongAnswer ?? ""),
  };
};

const injectTypeC = (
  html: string,
  optOrder?: string,
  enteredCorrectAnswer?: string,
  enteredWrongAnswer?: string
): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const mwInfoEl = doc.getElementById("KSD_MW_Info") as HTMLInputElement | null;
  const mwInfo = mwInfoEl?.value ?? "";
  const mwParts = mwInfo.split("|");

  const bgColorOdd = mwParts[1] ?? "#F8F8F8";
  const bgColorEven = mwParts[2] ?? "#FFFFFF";
  const optionImageType = parseInt(mwParts[8] ?? "0", 10) || 0;
  const styleStr = (mwParts[9] ?? "").toString().padStart(2, "0");
  const optionBgColorTransparent = parseInt(styleStr[0] ?? "0", 10) === 1;
  const imgConfig = getOptionImages(optionImageType);
  const SELECTED_BG = "#7a96df";

  // Re-order rows by opt_order (mirrors ReInit_C)
  if (optOrder && optOrder.trim()) {
    const order = optOrder.split("~").map(t => parseInt(t.trim(), 10)).filter(n => !isNaN(n));
    if (order.length > 0) {
      const tbody = doc.querySelector("#KSD_TABLE > tbody");
      if (tbody) {
        const rowMap = new Map<number, Element>();
        tbody.querySelectorAll("tr[id^='KSD_TR_']").forEach(tr => {
          const idx = parseInt((tr.getAttribute("id") ?? "").slice(7), 10);
          if (!isNaN(idx)) rowMap.set(idx, tr);
        });
        rowMap.forEach(tr => tr.parentNode?.removeChild(tr));
        order.forEach(origIdx => { const tr = rowMap.get(origIdx); if (tr) tbody.appendChild(tr); });
        tbody.querySelectorAll("tr[id^='KSD_TR_']").forEach((tr, vi) => {
          const label = tr.querySelector("font[id^='Ind_']");
          if (label) label.textContent = String.fromCharCode(65 + vi);
        });
      }
    }
  }

  // Hide KSD_TD1 (T4728), disable checkboxes
  doc.querySelectorAll("td[id='KSD_TD1']").forEach(td => { (td as HTMLElement).style.display = "none"; });
  doc.querySelectorAll("input[id^='Chk_']").forEach(input => { (input as HTMLInputElement).disabled = true; });

  // Background styles (same image logic as Type O)
  const styleEl = doc.createElement("style");
  if (optionImageType >= 2 && imgConfig) {
    styleEl.textContent = `
      #KSD_TABLE > tbody > tr[id^="KSD_TR_"] > td[id^="KSD_TD_"] {
        background-image: url(${imgConfig.normal}); background-repeat: no-repeat;
        background-color: transparent; cursor: pointer;
        padding-top: 5px !important; padding-bottom: 5px !important;
      }
      #KSD_TABLE > tbody > tr[id^="KSD_TR_"] { cursor: pointer; }
      [id^="KSD_TD_"] tbody > tr > td { font-size: 0px !important; }
    `;
  } else {
    const oddBg = optionBgColorTransparent ? "transparent" : bgColorOdd;
    const evenBg = optionBgColorTransparent ? "transparent" : bgColorEven;
    styleEl.textContent = `
      #KSD_TABLE > tbody > tr[id^="KSD_TR_"]:nth-child(odd)  { background-color: ${oddBg};  cursor: pointer; }
      #KSD_TABLE > tbody > tr[id^="KSD_TR_"]:nth-child(even) { background-color: ${evenBg}; cursor: pointer; }
      #KSD_TABLE > tbody > tr[id^="KSD_TR_"] { padding-top: 5px !important; padding-bottom: 5px !important; }
      [id^="KSD_TD_"] tbody > tr > td { font-size: 0px !important; }
    `;
  }
  doc.head.appendChild(styleEl);

  // Answer marking (mirrors MarkAns_C)
  const hasAnswerData =
    (enteredCorrectAnswer !== undefined && enteredCorrectAnswer.trim() !== "") ||
    (enteredWrongAnswer !== undefined && enteredWrongAnswer.trim() !== "");

  if (hasAnswerData) {
    const { correctOriginalIndices, selectedCorrectIndices, selectedWrongIndices } =
      parseTypeCAnswerIndices(enteredCorrectAnswer ?? "", enteredWrongAnswer ?? "");

    const ansSelector = optionImageType >= 2 ? "td[id^='KSD_TDANS_']" : "td[id^='TDANS_']";
    doc.querySelectorAll(ansSelector).forEach(td => { (td as HTMLElement).style.display = ""; });

    doc.querySelectorAll("tr[id^='KSD_TR_']").forEach(tr => {
      const originalIdx = parseInt((tr.getAttribute("id") ?? "").slice(7), 10);
      if (isNaN(originalIdx)) return;
      const ansTd = tr.querySelector(ansSelector) as HTMLElement | null;
      if (!ansTd) return;
      ansTd.querySelectorAll("img").forEach(img => img.remove());

      const isSelectedCorrect = selectedCorrectIndices.has(originalIdx);
      const isSelectedWrong = selectedWrongIndices.has(originalIdx);
      const isCorrectOption = correctOriginalIndices.has(originalIdx);

      let imgSrc = "", imgAlt = "";
      if (isSelectedCorrect) { imgSrc = AnsCorrect; imgAlt = "Correct Answer"; }
      else if (isSelectedWrong) { imgSrc = AnsWrong; imgAlt = "InCorrect Answer"; }
      else if (isCorrectOption) { imgSrc = AnsShouldbe; imgAlt = "Correct Answer"; }

      if (imgSrc) {
        const img = doc.createElement("img");
        img.setAttribute("id", "imgR"); img.src = imgSrc; img.alt = imgAlt;
        img.style.verticalAlign = "middle"; ansTd.appendChild(img);
      }
      if (optionImageType < 2 && (isSelectedCorrect || isSelectedWrong)) {
        (tr as HTMLElement).style.backgroundColor = SELECTED_BG;
      }
    });
  }

  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// TYPE F — Fill-in-the-blanks
// Isolated: only called when qn_catg === "F"
// Ported from EL_F.js: ReInit_F + MarkAns_F
// ─────────────────────────────────────────────────────────────────────────────

const applyTypeFReviewMarkup = (
  doc: Document,
  enteredCorrect: string,
  enteredWrong: string,
  enteredBlank: string,
  correctAnswers: string[]
): void => {
  const makeSpan = (text: string, color: string, extra?: Partial<CSSStyleDeclaration>): HTMLSpanElement => {
    const span = doc.createElement("span");
    span.style.backgroundColor = "transparent";
    span.style.fontFamily = "Verdana";
    span.style.color = color;
    if (extra) Object.assign(span.style, extra);
    span.textContent = text;
    return span;
  };

  const makeTickImg = (): HTMLImageElement => {
    const img = doc.createElement("img");
    img.setAttribute("id", "imgR"); img.src = AnsCorrect;
    img.alt = "Correct Answer"; img.style.verticalAlign = "middle";
    return img;
  };

  const hasPosPrefix = (raw: string): boolean => {
    if (!raw || !raw.trim()) return false;
    const tokens = raw.split("~").map(t => t.trim()).filter(Boolean);
    if (!tokens.length) return false;
    const allStart2Digits = tokens.every(t => t.length >= 2 && /^\d{2}/.test(t));
    return allStart2Digits && tokens.some(t => t.length > 2);
  };

  const parseTokenMap = (raw: string): Map<number, string> => {
    const map = new Map<number, string>();
    if (!raw || !raw.trim()) return map;
    if (hasPosPrefix(raw)) {
      for (const token of raw.split("~").map(t => t.trim()).filter(Boolean)) {
        if (token.length < 2) continue;
        const idx = parseInt(token.substring(0, 2), 10);
        if (!isNaN(idx)) map.set(idx, token.substring(2));
      }
    } else {
      raw.replace(/\|/g, "~").split("~").map(t => t.trim()).filter(Boolean)
        .forEach((val, i) => map.set(i, val));
    }
    return map;
  };

  const parseBlankSet = (raw: string): Set<number> => {
    const s = new Set<number>();
    if (!raw || !raw.trim()) return s;
    for (const token of raw.split("~").map(t => t.trim()).filter(Boolean)) {
      const idx = parseInt(token, 10);
      if (!isNaN(idx)) s.add(idx);
    }
    return s;
  };

  const correctMap = parseTokenMap(enteredCorrect);
  const wrongMap = parseTokenMap(enteredWrong);
  const blankSet = parseBlankSet(enteredBlank);

  const isAllCorrect = enteredCorrect !== "" && enteredWrong === "" && enteredBlank === "";
  const isSkipped = enteredCorrect === "" && enteredWrong === "" && enteredBlank === "";

  const getSpanAndInput = (idx: number) => {
    const spanHost = doc.getElementById(`span_${idx}`);
    const input = (spanHost?.querySelector(`input[id='KSD_BLANK_${idx}']`)
      ?? doc.getElementById(`KSD_BLANK_${idx}`)) as HTMLInputElement | null;
    return { spanHost, input };
  };

  if (isAllCorrect) {
    correctMap.forEach((enteredVal, idx) => {
      const { spanHost, input } = getSpanAndInput(idx);
      if (!spanHost) return;
      if (input) input.style.display = "none";
      spanHost.style.border = "none"; spanHost.style.borderBottom = "solid 2px red";
      const greenSpan = makeSpan(enteredVal, "green");
      greenSpan.appendChild(makeTickImg());
      spanHost.appendChild(greenSpan);
    });
  } else if (enteredWrong !== "" || enteredBlank !== "") {
    correctMap.forEach((enteredVal, idx) => {
      const { spanHost, input } = getSpanAndInput(idx);
      if (!spanHost) return;
      if (input) input.style.display = "none";
      spanHost.style.border = "none"; spanHost.style.borderBottom = "solid 2px red";
      const greenSpan = makeSpan(enteredVal, "green");
      greenSpan.appendChild(makeTickImg());
      spanHost.appendChild(greenSpan);
    });
    wrongMap.forEach((wrongVal, idx) => {
      const { spanHost, input } = getSpanAndInput(idx);
      if (!spanHost) return;
      if (input) input.style.display = "none";
      spanHost.style.border = "none"; spanHost.style.borderBottom = "solid 2px red";
      spanHost.appendChild(makeSpan(wrongVal, "red", { textDecoration: "line-through" }));
      spanHost.appendChild(doc.createTextNode("\u00a0"));
      spanHost.appendChild(makeSpan((correctAnswers[idx] ?? "").trim(), "green"));
    });
    blankSet.forEach(idx => {
      const { spanHost, input } = getSpanAndInput(idx);
      if (!spanHost) return;
      if (input) input.style.border = "solid 2px red";
      spanHost.style.border = "none"; spanHost.style.borderBottom = "solid 2px red";
      spanHost.appendChild(doc.createTextNode("\u00a0"));
      spanHost.appendChild(makeSpan((correctAnswers[idx] ?? "").trim(), "green"));
    });
  } else if (isSkipped) {
    doc.querySelectorAll("span[id^='span_']").forEach((spanHost, index) => {
      const input = spanHost.querySelector("input[id^='KSD_BLANK_']") as HTMLInputElement | null;
      if (input) { input.style.borderStyle = "none"; input.style.padding = "0px"; input.style.borderBottom = "solid 2px black"; }
      spanHost.appendChild(doc.createTextNode("\u00a0"));
      spanHost.appendChild(makeSpan((correctAnswers[index] ?? "").trim(), "red", { fontWeight: "bold" }));
    });
  }
};

const injectTypeF = (html: string, enteredCorrect: string, enteredWrong: string, enteredBlank: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const mwInfoEl = doc.getElementById("KSD_MW_Info") as HTMLInputElement | null;
  const mwParts = (mwInfoEl?.value ?? "").split("|");
  const doesHaveAnswerList = (mwParts[3] ?? "0") === "1";
  const fOptionImageType = mwParts[11] ?? "0";

  const bwEl = doc.getElementById("KSD_BW") as HTMLInputElement | null;
  const correctAnswers = (bwEl?.value ?? "").split("|").map(v => v.trim());

  const dividerBar = doc.getElementById("KSD_DIVIDERBAR");
  if (dividerBar) dividerBar.parentNode?.removeChild(dividerBar);

  const numPad = doc.getElementById("KSD_NUMPAD");
  if (numPad) numPad.parentNode?.removeChild(numPad);

  if (!doesHaveAnswerList) {
    const words2FillUp = doc.getElementById("KSD_WORDS2FILLUP");
    if (words2FillUp) words2FillUp.parentNode?.removeChild(words2FillUp);
  }

  applyTypeFReviewMarkup(doc, enteredCorrect, enteredWrong, enteredBlank, correctAnswers);

  doc.querySelectorAll("input[id^='KSD_BLANK_']").forEach(input => {
    (input as HTMLInputElement).readOnly = true;
  });

  if (doesHaveAnswerList) {
    const cellHeight = fOptionImageType === "4" ? "40px" : "55px";

    const styleEl = doc.createElement("style");
    styleEl.textContent = `
      td[id^='KSD_FIGTD_'] {
        background-image: linear-gradient(to bottom, #f0f7ff 0%, #dceeff 50%, #c8e3ff 100%) !important;
        background-color: transparent !important;
        border: 2px solid #a8c4e0 !important;
        border-radius: 4px !important;
        height: ${cellHeight} !important;
        min-width: 120px !important;
        text-align: center !important;
        cursor: default !important;
        pointer-events: none !important;
        font-family: Arial, sans-serif !important;
        color: #374d64 !important;
        padding: 4px 8px !important;
        box-sizing: border-box !important;
      }
      td[id^='KSD_FIGTD_'] span {
        color: #374d64 !important;
        font-size: 14pt !important;
      }
    `;
    doc.head.appendChild(styleEl);

    doc.querySelectorAll("td[id^='KSD_FIGTD_']").forEach(td => {
      td.removeAttribute("onmousedown");
      td.removeAttribute("onmousemove");
      td.removeAttribute("onmouseout");
      td.removeAttribute("onmouseup");
      td.removeAttribute("onclick");
    });
  }

  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// TYPE N — Number Wiz (column arithmetic with carry boxes)
// Isolated: only called when qn_catg === "N"
// Ported from EL_N.js: ReInit_N + MarkAns_N
// ─────────────────────────────────────────────────────────────────────────────

const injectTypeN = (html: string, enteredCorrect: string, enteredWrong: string, enteredBlank: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("input[id^='KSD_BLANK_'], input[id^='TXT_CARRY_']").forEach(input => {
    (input as HTMLInputElement).readOnly = true;
  });

  const bwEl = doc.getElementById("KSD_BW") as HTMLInputElement | null;
  const correctAnswers = (bwEl?.value ?? "").split("|").map(v => v.trim());

  const hasPosPrefix = (raw: string): boolean => {
    if (!raw || !raw.trim()) return false;
    const tokens = raw.split("~").map(t => t.trim()).filter(Boolean);
    if (!tokens.length) return false;
    const allStart2Digits = tokens.every(t => t.length >= 2 && /^\d{2}/.test(t));
    return allStart2Digits && tokens.some(t => t.length > 2);
  };

  const parseTokens = (raw: string): Map<number, string> => {
    const map = new Map<number, string>();
    if (!raw || !raw.trim()) return map;
    if (hasPosPrefix(raw)) {
      for (const token of raw.split("~").map(t => t.trim()).filter(Boolean)) {
        if (token.length < 2) continue;
        const idx = parseInt(token.substring(0, 2), 10);
        if (!isNaN(idx)) map.set(idx, token.substring(2));
      }
    } else {
      raw.replace(/\|/g, "~").split("~").map(t => t.trim()).filter(Boolean)
        .forEach((val, i) => map.set(i, val));
    }
    return map;
  };

  const parseIdxSet = (raw: string): Set<number> => {
    const s = new Set<number>();
    if (!raw || !raw.trim()) return s;
    for (const t of raw.split("~").map(x => x.trim()).filter(Boolean)) {
      const n = parseInt(t, 10); if (!isNaN(n)) s.add(n);
    }
    return s;
  };

  const splitParts = (raw: string): [string, string] => {
    const ci = raw.indexOf(",");
    return ci === -1 ? [raw, ""] : [raw.substring(0, ci), raw.substring(ci + 1)];
  };

  const [blankCorrectRaw, carryCorrectRaw] = splitParts(enteredCorrect);
  const [blankWrongRaw, carryWrongRaw] = splitParts(enteredWrong);
  const [blankBlankRaw, carryBlankRaw] = splitParts(enteredBlank);

  const blankCorrectMap = parseTokens(blankCorrectRaw);
  const carryCorrectMap = parseTokens(carryCorrectRaw);
  const blankWrongMap = parseTokens(blankWrongRaw);
  const carryWrongMap = parseTokens(carryWrongRaw);
  const blankBlankSet = parseIdxSet(blankBlankRaw);
  const carryBlankSet = parseIdxSet(carryBlankRaw);

  const makeSpan = (text: string, css: Partial<CSSStyleDeclaration>): HTMLSpanElement => {
    const span = doc.createElement("span");
    Object.assign(span.style, { backgroundColor: "transparent", border: "none", ...css });
    span.textContent = text;
    return span;
  };

  const insertAfter = (newEl: Element, refEl: Element) => {
    refEl.parentNode?.insertBefore(newEl, refEl.nextSibling);
  };

  const isAllBlankCorrect = blankCorrectRaw.trim() !== "" && blankWrongRaw.trim() === "";
  const isSomeWrongOrBlank = blankWrongRaw.trim() !== "" || enteredBlank.trim() !== "";
  const isSkipped = enteredCorrect.trim() === "" && enteredWrong.trim() === "" && enteredBlank.trim() === "";

  if (isAllBlankCorrect) {
    blankCorrectMap.forEach((val, idx) => {
      const input = (doc.querySelector(`input[id='KSD_BLANK_${idx}']`) ??
        doc.querySelectorAll("input[id^='KSD_BLANK_']")[idx]) as HTMLElement | null;
      if (!input) return;
      insertAfter(makeSpan(val, { color: "green", borderBottom: "2px solid red" }), input);
      (input as HTMLElement).style.display = "none";
    });
    carryCorrectMap.forEach((val, idx) => {
      const input = doc.querySelector(`input[id='TXT_CARRY_${idx}']`) as HTMLElement | null;
      if (!input) return;
      insertAfter(makeSpan(val, { fontSize: "15pt", marginLeft: "20px" }), input);
      (input as HTMLElement).style.display = "none";
    });
    carryWrongMap.forEach((val, idx) => {
      const input = doc.querySelector(`input[id='TXT_CARRY_${idx}']`) as HTMLElement | null;
      if (!input) return;
      const ps = makeSpan("", { fontSize: "15pt", marginLeft: "20px" });
      ps.appendChild(makeSpan(val, {}));
      insertAfter(ps, input);
      (input as HTMLElement).style.display = "none";
    });
  } else if (isSomeWrongOrBlank) {
    blankCorrectMap.forEach((val, idx) => {
      const input = doc.querySelector(`input[id='KSD_BLANK_${idx}']`) as HTMLElement | null;
      if (!input) return;
      insertAfter(makeSpan(val, { color: "green", borderBottom: "2px solid red" }), input);
      (input as HTMLElement).style.display = "none";
    });
    carryCorrectMap.forEach((val, idx) => {
      const input = doc.querySelector(`input[id='TXT_CARRY_${idx}']`) as HTMLElement | null;
      if (!input) return;
      insertAfter(makeSpan(val, { fontSize: "15pt", marginLeft: "20px" }), input);
      (input as HTMLElement).style.display = "none";
    });
    blankWrongMap.forEach((wrongVal, idx) => {
      const input = doc.querySelector(`input[id='KSD_BLANK_${idx}']`) as HTMLElement | null;
      if (!input) return;
      const correctVal = (correctAnswers[idx] ?? "").trim();
      const ps = makeSpan("", { borderBottom: "2px solid red" });
      ps.appendChild(makeSpan(wrongVal, { color: "red", backgroundColor: "yellow", textDecoration: "line-through" }));
      ps.appendChild(doc.createTextNode("\u00a0"));
      ps.appendChild(makeSpan(correctVal, { color: "green" }));
      insertAfter(ps, input);
      (input as HTMLElement).style.display = "none";
    });
    carryWrongMap.forEach((wrongVal, idx) => {
      const input = doc.querySelector(`input[id='TXT_CARRY_${idx}']`) as HTMLElement | null;
      if (!input) return;
      const ps = makeSpan("", { fontSize: "15pt", marginLeft: "20px" });
      ps.appendChild(makeSpan(wrongVal, {}));
      insertAfter(ps, input);
      (input as HTMLElement).style.display = "none";
    });
    blankBlankSet.forEach(idx => {
      const input = doc.querySelector(`input[id='KSD_BLANK_${idx}']`) as HTMLInputElement | null;
      if (!input) return;
      input.style.backgroundColor = "yellow"; input.style.border = "1px dashed black";
      insertAfter(makeSpan((correctAnswers[idx] ?? "").trim(), { color: "green" }), input);
    });
    carryBlankSet.forEach(idx => {
      const input = doc.querySelector(`input[id='TXT_CARRY_${idx}']`) as HTMLInputElement | null;
      if (!input) return;
      input.style.border = "1px dashed black";
      insertAfter(makeSpan("", { color: "green", fontSize: "15pt", marginLeft: "20px" }), input);
    });
  } else if (isSkipped) {
    doc.querySelectorAll("input[id^='KSD_BLANK_'], input[id^='TXT_CARRY_']").forEach(input => {
      (input as HTMLElement).style.border = "1px dashed black";
    });
    doc.querySelectorAll("input[id^='KSD_BLANK_']").forEach((input, index) => {
      insertAfter(makeSpan((correctAnswers[index] ?? "").trim(), { color: "green" }), input);
    });
    doc.querySelectorAll("input[id^='TXT_CARRY_']").forEach(input => {
      const carryName = (input as HTMLInputElement).name ?? "";
      if (carryName === "-" || carryName === "") return;
      insertAfter(makeSpan(carryName, { fontSize: "15pt", marginLeft: "20px" }), input);
    });
  }

  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// TYPE W — Word Questions
// Isolated: only called when qn_catg === "W"
// Ported from EL_W.js: ReInit_W + MarkAns_W
// ─────────────────────────────────────────────────────────────────────────────

// const injectTypeW = (html: string, enteredCorrect: string, enteredWrong: string): string => {
//   const parser = new DOMParser();
//   const doc    = parser.parseFromString(html, "text/html");

//   const ksdW = doc.getElementById("KSD_W") as HTMLTextAreaElement | HTMLInputElement | null;
//   if (ksdW) {
//     (ksdW as HTMLInputElement).disabled = true;
//     ksdW.style.border           = "solid 2px skyblue";
//     ksdW.style.backgroundColor  = "white";
//     ksdW.style.opacity          = "1";
//   }

//   const wPad = doc.getElementById("KSD_W_PAD");
//   if (wPad) wPad.parentNode?.removeChild(wPad);

//   const dividerBar = doc.getElementById("KSD_DIVIDERBAR");
//   if (dividerBar) dividerBar.parentNode?.removeChild(dividerBar);

//   const numpad = doc.getElementById("KSD_NUMPAD");
//   if (numpad) numpad.parentNode?.removeChild(numpad);

//   const mwCaEl   = doc.getElementById("KSD_MW_CA") as HTMLInputElement | null;
//   const mwCaVal  = (mwCaEl?.value ?? "").split("^^")[0];

//   const injectImg = (tdId: string, src: string, alt: string) => {
//     const td = doc.getElementById(tdId);
//     if (!td) return;
//     td.innerHTML = "";
//     const img = doc.createElement("img");
//     img.setAttribute("id", "imgR");
//     img.src                 = src;
//     img.alt                 = alt;
//     img.style.verticalAlign = "middle";
//     td.appendChild(img);
//     (td as HTMLElement).style.display = "";
//   };

//   if (enteredCorrect !== "" && enteredWrong === "") {
//     injectImg("KSD_TDANS_0", AnsCorrect, "Correct Answer");
//     if (ksdW) (ksdW as HTMLInputElement).value = enteredCorrect;

//   } else if (enteredCorrect === "" && enteredWrong !== "") {
//     injectImg("KSD_TDANS_0", AnsWrong, "Incorrect Answer");
//     if (ksdW) (ksdW as HTMLInputElement).value = enteredWrong;
//     injectImg("KSD_TDANS_1", AnsShouldbe, "Correct Answer");

//     const tdansOk = doc.getElementById("KSD_TDANSOK");
//     if (tdansOk) {
//       tdansOk.textContent        = mwCaVal;
//       tdansOk.style.display      = "";
//       tdansOk.style.fontFamily   = "Verdana";
//       tdansOk.style.color        = "green";
//       tdansOk.style.fontWeight   = "normal";
//       tdansOk.style.fontSize     = "15pt";
//     }

//   } else {
//     injectImg("KSD_TDANS_0", AnsWrong, "Incorrect Answer");
//     injectImg("KSD_TDANS_1", AnsShouldbe, "Correct Answer");

//     const tdansOk = doc.getElementById("KSD_TDANSOK");
//     if (tdansOk) {
//       tdansOk.textContent        = mwCaVal;
//       tdansOk.style.display      = "";
//       tdansOk.style.fontFamily   = "Verdana";
//       tdansOk.style.color        = "green";
//       tdansOk.style.fontWeight   = "normal";
//       tdansOk.style.fontSize     = "15pt";
//     }
//   }

//   return doc.documentElement.outerHTML;
// };

const injectTypeW = (html: string, enteredCorrect: string, enteredWrong: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const ksdW = doc.getElementById("KSD_W") as HTMLTextAreaElement | HTMLInputElement | null;
  if (ksdW) {
    (ksdW as HTMLInputElement).disabled = true;
    ksdW.style.border = "solid 2px skyblue";
    ksdW.style.backgroundColor = "white";
    ksdW.style.opacity = "1";
  }

  const wPad = doc.getElementById("KSD_W_PAD");
  if (wPad) wPad.parentNode?.removeChild(wPad);

  const dividerBar = doc.getElementById("KSD_DIVIDERBAR");
  if (dividerBar) dividerBar.parentNode?.removeChild(dividerBar);

  const numpad = doc.getElementById("KSD_NUMPAD");
  if (numpad) numpad.parentNode?.removeChild(numpad);

  const mwCaEl = doc.getElementById("KSD_MW_CA") as HTMLInputElement | null;
  const mwCaVal = (mwCaEl?.value ?? "").split("^^")[0];

  // ── Helper: sets value in a way that survives outerHTML serialization ──────
  // .value is a DOM property — it does NOT appear in serialized HTML.
  // For <textarea>, content lives between the tags → use textContent.
  // For <input>,    content lives in the value attribute → use setAttribute.
  const setKsdWValue = (el: Element | null, val: string) => {
    if (!el) return;
    if (el.tagName.toLowerCase() === "textarea") {
      el.textContent = val;           // serializes correctly in outerHTML
    } else {
      el.setAttribute("value", val);  // for input elements
    }
  };

  const injectImg = (tdId: string, src: string, alt: string) => {
    const td = doc.getElementById(tdId);
    if (!td) return;
    td.innerHTML = "";
    const img = doc.createElement("img");
    img.setAttribute("id", "imgR");
    img.src = src;
    img.alt = alt;
    img.style.verticalAlign = "middle";
    td.appendChild(img);
    (td as HTMLElement).style.display = "";
  };

  if (enteredCorrect !== "" && enteredWrong === "") {
    // ── All correct ──────────────────────────────────────────────────────────
    injectImg("KSD_TDANS_0", AnsCorrect, "Correct Answer");
    setKsdWValue(ksdW, enteredCorrect);

  } else if (enteredCorrect === "" && enteredWrong !== "") {
    // ── Wrong answer ─────────────────────────────────────────────────────────
    injectImg("KSD_TDANS_0", AnsWrong, "Incorrect Answer");
    setKsdWValue(ksdW, enteredWrong);
    injectImg("KSD_TDANS_1", AnsShouldbe, "Correct Answer");

    const tdansOk = doc.getElementById("KSD_TDANSOK");
    if (tdansOk) {
      tdansOk.textContent = mwCaVal;
      tdansOk.style.display = "";
      tdansOk.style.fontFamily = "Verdana";
      tdansOk.style.color = "green";
      tdansOk.style.fontWeight = "normal";
      tdansOk.style.fontSize = "15pt";
    }

  } else {
    // ── Skipped (both empty) ─────────────────────────────────────────────────
    injectImg("KSD_TDANS_0", AnsWrong, "Incorrect Answer");
    injectImg("KSD_TDANS_1", AnsShouldbe, "Correct Answer");

    const tdansOk = doc.getElementById("KSD_TDANSOK");
    if (tdansOk) {
      tdansOk.textContent = mwCaVal;
      tdansOk.style.display = "";
      tdansOk.style.fontFamily = "Verdana";
      tdansOk.style.color = "green";
      tdansOk.style.fontWeight = "normal";
      tdansOk.style.fontSize = "15pt";
    }
  }

  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// TYPE M — Mix and Match Questions
// Isolated: only called when qn_catg === "M"
// Ported from EL_M.js: ReInit_M + MarkAns_M
//
// Answer format from DB (ChkAns_M output):
//   correct_ans  = EnteredCorrectAnswer = LHSOrder (comma-separated, ~-joined)
//                  e.g. "0~1~2~3"  (the LHS side — always the "key")
//   wrong_ans    = EnteredWrongAnswer   = RHSOrder (comma-separated, ~-joined)
//                  e.g. "2~0~3~1"  (the RHS side as the student left it)
//   opt_order    = ShuffledOptionsOrder = LHSOrder~RHSOrder at time of answering
//                  e.g. "0,1,2,3~2,0,3,1"
//   both correct_ans and wrong_ans empty = skipped
//
// ReInit_M behaviour (review mode — restores the shuffled layout from DB):
//   Uses opt_order to re-arrange LHS and RHS columns back to how the student saw them.
//   Removes LHS1/RHS1 (static display variants), sets LHS2/RHS2 styles,
//   removes interactive onmouseup/onmousemove from body.
//
// MarkAns_M behaviour (three branches, mirrors JS exactly):
//   All correct  (enteredCorrect != "" && enteredWrong == ""):
//     → AnsCorrect.GIF in every TDANS_ cell
//   Some wrong   (both non-empty):
//     → Per-row: AnsCorrect if LHS[i]==RHS[i], AnsWrong otherwise
//   Skipped      (both empty):
//     → Per-row: AnsCorrect if LHS2_[i] id suffix == RHS2_[i] id suffix (i.e. still default), AnsWrong otherwise
// ─────────────────────────────────────────────────────────────────────────────

const injectTypeM = (
  html: string,
  enteredCorrectAnswer: string,  // LHSOrder from DB  e.g. "0~1~2~3"
  enteredWrongAnswer: string,    // RHSOrder from DB  e.g. "2~0~3~1"
  shuffledOptionsOrder: string   // opt_order from DB e.g. "0,1,2,3~2,0,3,1"
): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // ── Read KSD_MW_Info for background colours (mirrors ReInit_M) ─────────────
  const mwInfoEl = doc.getElementById("KSD_MW_Info") as HTMLInputElement | null;
  const mwParts = (mwInfoEl?.value ?? "").split("|");
  const bgEven = mwParts[0] ?? "#FFFFFF";
  const bgOdd = mwParts[1] ?? "#F8F8F8";

  // ── ReInit_M: remove LHS1 and RHS1, style LHS2 and RHS2 ──────────────────
  // mirrors: Remove td[id^=LHS1_] and td[id^=RHS1_] from every row
  doc.querySelectorAll("td[id^='LHS1_']").forEach(td => td.parentNode?.removeChild(td));
  doc.querySelectorAll("td[id^='RHS1_']").forEach(td => td.parentNode?.removeChild(td));

  // mirrors: LHS2 → border: 1px solid black, cursor: default
  doc.querySelectorAll("td[id^='LHS2_']").forEach(td => {
    (td as HTMLElement).style.border = "1px solid black";
    (td as HTMLElement).style.cursor = "default";
    (td as HTMLElement).style.width = "";
  });

  // mirrors: RHS2 → border: 1px dashed grey, cursor: pointer
  // In review mode we override cursor to default since it's not interactive
  doc.querySelectorAll("td[id^='RHS2_']").forEach(td => {
    (td as HTMLElement).style.border = "1px dashed grey";
    (td as HTMLElement).style.cursor = "default";  // non-interactive in review
    (td as HTMLElement).style.width = "";
  });

  // mirrors: KSD_TABLE → border-collapse: collapse
  const ksdTable = doc.getElementById("KSD_TABLE") as HTMLElement | null;
  if (ksdTable) ksdTable.style.borderCollapse = "collapse";

  // ── ReInit_M: re-order LHS and RHS columns from shuffledOptionsOrder ───────
  // shuffledOptionsOrder = "LHSOrder~RHSOrder"
  // LHSOrder and RHSOrder are comma-separated original indices
  // e.g. "0,2,1,3~3,1,0,2" means:
  //   LHS row 0 should show original option 0
  //   LHS row 1 should show original option 2  …etc
  //   RHS row 0 should show original option 3  …etc
  if (shuffledOptionsOrder && shuffledOptionsOrder.trim()) {
    const parts = shuffledOptionsOrder.split("~");
    const lhsOrder = (parts[0] ?? "").split(",").map(t => parseInt(t.trim(), 10)).filter(n => !isNaN(n));
    const rhsOrder = (parts[1] ?? "").split(",").map(t => parseInt(t.trim(), 10)).filter(n => !isNaN(n));

    const tbody = doc.querySelector("#KSD_TABLE > tbody") as HTMLElement | null;
    if (tbody && lhsOrder.length > 0) {
      // Collect all LHS2 and RHS2 elements keyed by their original index (id suffix)
      const lhsMap = new Map<number, Element>();
      const rhsMap = new Map<number, Element>();

      doc.querySelectorAll("td[id^='LHS2_']").forEach(td => {
        const suffix = parseInt((td.getAttribute("id") ?? "").substring(5), 10);
        if (!isNaN(suffix)) lhsMap.set(suffix, td);
      });
      doc.querySelectorAll("td[id^='RHS2_']").forEach(td => {
        const suffix = parseInt((td.getAttribute("id") ?? "").substring(5), 10);
        if (!isNaN(suffix)) rhsMap.set(suffix, td);
      });

      // Detach all LHS2 and RHS2 from DOM
      lhsMap.forEach(td => td.parentNode?.removeChild(td));
      rhsMap.forEach(td => td.parentNode?.removeChild(td));

      // Trim extra rows beyond the number of options stored (mirrors ReInit_M while loop)
      const noOfOptions = Math.max(lhsOrder.length, rhsOrder.length);
      const rows = Array.from(tbody.querySelectorAll("tr[id^='KSD_TR_'], tr"));
      while (rows.length > noOfOptions) {
        const last = rows.pop();
        if (last) last.parentNode?.removeChild(last);
      }

      const allRows = Array.from(tbody.querySelectorAll("tr"));

      // Re-attach LHS2 to rows in stored LHS order (prepend, mirrors ReInit_M)
      lhsOrder.forEach((origIdx, rowIdx) => {
        const row = allRows[rowIdx];
        const lhsTd = lhsMap.get(origIdx);
        if (row && lhsTd) row.insertBefore(lhsTd, row.firstChild);
      });

      // Re-attach RHS2 to rows in stored RHS order (insertAfter LHS2, mirrors ReInit_M)
      rhsOrder.forEach((origIdx, rowIdx) => {
        const row = allRows[rowIdx];
        const rhsTd = rhsMap.get(origIdx);
        if (!row || !rhsTd) return;
        const lhsTd = row.querySelector("td[id^='LHS2_']");
        if (lhsTd && lhsTd.nextSibling) {
          row.insertBefore(rhsTd, lhsTd.nextSibling);
        } else if (lhsTd) {
          row.appendChild(rhsTd);
        } else {
          row.appendChild(rhsTd);
        }
      });
    }
  }

  // ── Apply background colours to rows (mirrors ReInit_M) ───────────────────
  // CSS :nth-child(even/odd) from JS perspective: jQuery :even = 0-indexed even = CSS :odd
  // We apply inline to match the JS behaviour exactly
  const allRows = Array.from(doc.querySelectorAll("#KSD_TABLE > tbody > tr"));
  allRows.forEach((tr, i) => {
    // jQuery :even = 0-indexed even rows (0,2,4…) → CSS nth-child(odd)
    (tr as HTMLElement).style.backgroundColor = i % 2 === 0 ? bgEven : bgOdd;
  });

  // ── Remove interactive attributes from body (mirrors ReInit_M) ────────────
  const body = doc.querySelector("body");
  if (body) {
    body.removeAttribute("onmouseup");
    body.removeAttribute("onmousemove");
    body.setAttribute("leftmargin", "15");
  }

  // ── MarkAns_M: show answer images in TDANS_ cells ─────────────────────────
  // First make all TDANS_ cells visible (mirrors: $(...TDANS_).show())
  doc.querySelectorAll("td[id^='TDANS_']").forEach(td => {
    (td as HTMLElement).style.display = "";
  });

  const lhsArr = enteredCorrectAnswer.split("~").map(t => t.trim());
  const rhsArr = enteredWrongAnswer.split("~").map(t => t.trim());

  const makeImg = (src: string, alt: string): HTMLImageElement => {
    const img = doc.createElement("img");
    img.setAttribute("id", "imgR");
    img.src = src;
    img.alt = alt;
    img.style.verticalAlign = "middle";
    return img;
  };

  const isAllCorrect = enteredCorrectAnswer !== "" && enteredWrongAnswer === "";
  const isSomeWrong = enteredCorrectAnswer !== "" && enteredWrongAnswer !== "";
  const isSkipped = enteredCorrectAnswer === "" && enteredWrongAnswer === "";

  if (isAllCorrect) {
    // All options matched correctly → AnsCorrect in every TDANS_ cell
    doc.querySelectorAll("td[id^='TDANS_']").forEach(td => {
      td.innerHTML = "";
      td.appendChild(makeImg(AnsCorrect, "Correct Answer"));
    });

  } else if (isSomeWrong) {
    // Per-row: compare lhsArr[i] vs rhsArr[i]
    // The rows are now in shuffled visual order; TDANS_ belongs to each <tr>
    doc.querySelectorAll("#KSD_TABLE > tbody > tr").forEach((tr, index) => {
      const ansTd = tr.querySelector("td[id^='TDANS_']");
      if (!ansTd) return;
      ansTd.innerHTML = "";
      // lhsArr and rhsArr are in the original positional order from ChkAns_M
      // LHS[i] == RHS[i] means that row was matched correctly
      if (lhsArr[index] !== undefined && rhsArr[index] !== undefined && lhsArr[index] === rhsArr[index]) {
        ansTd.appendChild(makeImg(AnsCorrect, "Correct Answer"));
      } else {
        ansTd.appendChild(makeImg(AnsWrong, "Incorrect Answer"));
      }
    });

  } else if (isSkipped) {
    // Skipped: check if LHS2_ id suffix matches RHS2_ id suffix in current DOM order
    // mirrors: if LHS2_.attr("id").substr(5) == RHS2_.attr("id").substr(5) → Correct, else Wrong
    doc.querySelectorAll("#KSD_TABLE > tbody > tr").forEach(tr => {
      const ansTd = tr.querySelector("td[id^='TDANS_']");
      const lhsTd = tr.querySelector("td[id^='LHS2_']");
      const rhsTd = tr.querySelector("td[id^='RHS2_']");
      if (!ansTd) return;
      ansTd.innerHTML = "";
      const lhsSuffix = (lhsTd?.getAttribute("id") ?? "").substring(5);
      const rhsSuffix = (rhsTd?.getAttribute("id") ?? "").substring(5);
      if (lhsSuffix !== "" && lhsSuffix === rhsSuffix) {
        ansTd.appendChild(makeImg(AnsCorrect, "Correct Answer"));
      } else {
        ansTd.appendChild(makeImg(AnsWrong, "Incorrect Answer"));
      }
    });
  }

  return doc.documentElement.outerHTML;
};

// ─────────────────────────────────────────────────────────────────────────────
// CORRECT-ANSWER EXTRACTORS  (shared, used by all types)
// ─────────────────────────────────────────────────────────────────────────────

const extractCorrectAnswerFromIframe = (doc: Document, win: Window | null, qnType: string): string => {
  try {
    if (qnType === "O") {
      const parts = getDocValue(doc, "KSD_MW_Info").split("|");
      const idx = parseInt(parts[3] ?? "", 10);
      return Number.isNaN(idx) ? "" : String(idx);
    }
    if (qnType === "C") {
      const parts = getDocValue(doc, "KSD_MW_Info").split("|");
      if (parts.length > 4) return Array.from(parts[4]).map((_, i) => String(parts[4].charCodeAt(i) - 65)).join(", ");
      return "";
    }
    if (qnType === "F" || qnType === "N") {
      const bwVal = getDocValue(doc, "KSD_BW");
      return bwVal ? bwVal.split("|").filter(Boolean).join(", ") : "";
    }
    if (qnType === "D") return "1";
    if (qnType === "M" || qnType === "L") return "Question itself correct";
    if (qnType === "W") return getDocValue(doc, "KSD_MW_CA").split("^^")[0];
    if (qnType === "B") return getDocValue(doc, "KSD_MW_Info").split("|")[4] ?? "";
  } catch { return ""; }
  return "";
};

const extractCorrectAnswerFromHtmlDoc = (doc: Document, qnType: string): string => {
  const getValue = (id: string) => (doc.getElementById(id) as HTMLInputElement | HTMLTextAreaElement | null)?.value?.trim() ?? "";
  if (qnType === "O") return getValue("KSD_MW_Info").split("|")[3] ?? "";
  if (qnType === "C") {
    const parts = getValue("KSD_MW_Info").split("|");
    if (parts.length <= 4) return "";
    return Array.from(parts[4]).map((_, i) => String(parts[4].charCodeAt(i) - 65)).join(", ");
  }
  if (qnType === "F" || qnType === "N") return getValue("KSD_BW").split("|").filter(Boolean).join(", ");
  if (qnType === "D") return "1";
  if (qnType === "M" || qnType === "L") return "Question itself correct";
  if (qnType === "W") return getValue("KSD_MW_CA").split("^^")[0];
  if (qnType === "B") return getValue("KSD_MW_Info").split("|")[4] ?? "";
  return "";
};

const fetchCorrectAnswerFromQuestionFile = async (qnFileUrl: string, qnType: string): Promise<string> => {
  const response = await fetch(qnFileUrl);
  if (!response.ok) throw new Error(`Failed to fetch question file: ${response.status}`);
  return extractCorrectAnswerFromHtmlDoc(
    new DOMParser().parseFromString(await response.text(), "text/html"),
    qnType
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

const EC_ViewQuestion: React.FC = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [showNumpad, setShowNumpad] = useState(false);

  document.body.style.backgroundColor = "#fff";

  // ── URL-driven init ───────────────────────────────────────────────────────
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const init = async () => {
      if (qs.get("source") === "navreport" && qs.get("strand")) {
        dispatch({ type: "SET_LOADING", payload: true });
        try {
          let correctAns = qs.get("correct_ans") ?? "";
          let wrongAns = qs.get("wrong_ans") ?? "";
          let optOrder = qs.get("opt_order") ?? "";
          let blankAns = qs.get("blank_ans") ?? "";

          if (!correctAns && !wrongAns && !blankAns &&
            qs.get("StuSch") && qs.get("StuFam") && qs.get("StudentId") && qs.get("ReportNo")) {
            const rp = new URLSearchParams({
              stu_sch: qs.get("StuSch") ?? "", stu_fam: qs.get("StuFam") ?? "",
              stu_id: qs.get("StudentId") ?? "", report_no: qs.get("ReportNo") ?? "",
            });
            const reportData = await apiFetch<{ questions: QuestionStub[]; current_question: QuestionData; warning?: string }>(`${API_BASE_URL}api/report/EC/?${rp}`);
            const matched = reportData.questions.find(q =>
              String(q.strand) === String(qs.get("strand")) && String(q.substrand) === String(qs.get("substrand")) &&
              String(q.yr) === String(qs.get("yr")) && String(q.topic) === String(qs.get("topic")) &&
              String(q.qn_no) === String(qs.get("qn_no"))
            );
            if (matched) {
              correctAns = matched.correct_ans ?? ""; wrongAns = matched.wrong_ans ?? "";
              optOrder = matched.opt_order ?? ""; blankAns = matched.blank_ans ?? "";
            }
          }

          const p = new URLSearchParams({
            strand: qs.get("strand") ?? "0", substrand: qs.get("substrand") ?? "0",
            yr: qs.get("yr") ?? "0", topic: qs.get("topic") ?? "0", qn_no: qs.get("qn_no") ?? "0",
            country: qs.get("country") ?? "", curriculum: qs.get("curriculum") ?? "",
            correct_ans: correctAns, wrong_ans: wrongAns, opt_order: optOrder, blank_ans: blankAns,
            stu_sch: qs.get("StuSch") ?? "", stu_fam: qs.get("StuFam") ?? "",
            stu_id: qs.get("StudentId") ?? "", report_no: qs.get("ReportNo") ?? "",
          });
          const data = await apiFetch<QuestionData>(`${API_BASE_URL}api/by-report-params/EC/?${p}`);
          if (data.warning) dispatch({ type: "SET_WARNING", payload: data.warning });
          else dispatch({ type: "SET_SEARCH_RESULT", questions: [], current: data });
        } catch (e) { dispatch({ type: "SET_WARNING", payload: String(e) }); }
        return;
      }

      if (qs.get("strand")) {
        dispatch({ type: "SET_LOADING", payload: true });
        try {
          const p = new URLSearchParams({
            strand: qs.get("strand") ?? "0", substrand: qs.get("substrand") ?? "0",
            yr: qs.get("yr") ?? "0", topic: qs.get("topic") ?? "0", qn_no: qs.get("qn_no") ?? "0",
            country: qs.get("country") ?? "", curriculum: qs.get("curriculum") ?? "",
          });
          const data = await apiFetch<QuestionData>(`${API_BASE_URL}api/by-params/EC/?${p}`);
          dispatch({ type: "SET_SEARCH_RESULT", questions: [], current: data });
        } catch (e) { dispatch({ type: "SET_WARNING", payload: String(e) }); }
        return;
      }

      if (qs.get("stu_sch") && qs.get("stu_fam") && qs.get("stu_id")) {
        dispatch({ type: "SET_LOADING", payload: true });
        try {
          const p = new URLSearchParams({
            stu_sch: qs.get("stu_sch") ?? "", stu_fam: qs.get("stu_fam") ?? "",
            stu_id: qs.get("stu_id") ?? "", report_no: qs.get("report_no") ?? "",
          });
          const data = await apiFetch<{ questions: QuestionStub[]; current_question: QuestionData; warning?: string }>(`${API_BASE_URL}api/report/EC/?${p}`);
          if (data.warning) dispatch({ type: "SET_WARNING", payload: data.warning });
          else dispatch({ type: "SET_REPORT_MODE", questions: data.questions, current: data.current_question });
        } catch (e) { dispatch({ type: "SET_WARNING", payload: String(e) }); }
        return;
      }

      setTimeout(() => dispatch({ type: "OVERLAY_HIDE" }), 400);
    };
    init();
  }, []);

  // ── iframe resize ─────────────────────────────────────────────────────────
  const resizeIframe = useCallback(() => {
    const iframe = iframeRef.current;
    const header = headerRef.current;
    if (!iframe) return;
    const h = window.innerHeight - (header?.offsetHeight ?? 79);
    iframe.style.height = `${Math.max(h, 250)}px`;
    iframe.style.width = "100%";
  }, []);

  useEffect(() => {
    resizeIframe();
    window.addEventListener("resize", resizeIframe);
    return () => window.removeEventListener("resize", resizeIframe);
  }, [resizeIframe, state.current]);

  useEffect(() => {
    if (!state.loading && state.current) {
      const t = setTimeout(() => dispatch({ type: "OVERLAY_HIDE" }), 500);
      return () => clearTimeout(t);
    }
  }, [state.loading, state.current]);

  // ── iframe onLoad ─────────────────────────────────────────────────────────
  const handleIframeLoad = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe || !state.current) return;
    dispatch({ type: "IFRAME_READY" });

    const qd = state.current;

    // Virtual numpad: shown only for interactive F/N in non-review mode
    setShowNumpad((qd.qn_catg === "F" || qd.qn_catg === "N") && qd.virtual_keypad === "Y");

    // Send legacy bridge init
    iframe.contentWindow?.postMessage({
      type: "MD_INIT", QnType: qd.qn_catg, KatMode: 1, TestMode: 0,
      TestRepMode: state.showWrongAns ? 1 : 0,
      showVirtualKeypad: qd.virtual_keypad, hidQnInfo: qd.qn_info ?? "",
      ShowWAns: state.showWrongAns ? "Y" : "",
    }, "*");

    // ── Type O ───────────────────────────────────────────────────────────────
    if (qd.qn_catg === "O" && qd.qn_html) {
      let resolvedCorrectIndex = qd.EnteredCorrectAnswer ?? "";
      if (!resolvedCorrectIndex) {
        try {
          const mwInfo = (new DOMParser().parseFromString(qd.qn_html, "text/html")
            .getElementById("KSD_MW_Info") as HTMLInputElement | null)?.value ?? "";
          const idx = parseInt(mwInfo.split("|")[3] ?? "", 10);
          if (!Number.isNaN(idx)) resolvedCorrectIndex = String(idx);
        } catch { /* ignore */ }
      }
      dispatch({
        type: "SET_QN_HTML_OVERRIDE",
        payload: injectTypeO(
          qd.qn_html,
          qd.correct_ans ?? "",
          qd.wrong_ans ?? "",
          resolvedCorrectIndex,
          qd.opt_order ?? ""
        )
      });
    }

    // ── Type C ───────────────────────────────────────────────────────────────
    if (qd.qn_catg === "C" && qd.qn_html) {
      dispatch({ type: "SET_QN_HTML_OVERRIDE", payload: injectTypeC(qd.qn_html, qd.opt_order, qd.EnteredCorrectAnswer, qd.EnteredWrongAnswer) });
    }

    // ── Type F ───────────────────────────────────────────────────────────────
    if (qd.qn_catg === "F" && qd.qn_html) {
      try {
        dispatch({ type: "SET_QN_HTML_OVERRIDE", payload: injectTypeF(qd.qn_html, qd.correct_ans ?? "", qd.wrong_ans ?? "", qd.blank_ans ?? "") });
      } catch (err) { console.error("injectTypeF error:", err); }
    }

    // ── Type N ───────────────────────────────────────────────────────────────
    if (qd.qn_catg === "N" && qd.qn_html) {
      try {
        dispatch({ type: "SET_QN_HTML_OVERRIDE", payload: injectTypeN(qd.qn_html, qd.correct_ans ?? "", qd.wrong_ans ?? "", qd.blank_ans ?? "") });
      } catch (err) { console.error("injectTypeN error:", err); }
    }

    // ── Type W ───────────────────────────────────────────────────────────────
    if (qd.qn_catg === "W" && qd.qn_html) {
      try {
        dispatch({ type: "SET_QN_HTML_OVERRIDE", payload: injectTypeW(qd.qn_html, qd.correct_ans ?? "", qd.wrong_ans ?? "") });
      } catch (err) { console.error("injectTypeW error:", err); }
    }

    // ── Type M — Mix and Match ────────────────────────────────────────────────
    // Isolated: only runs when qn_catg === "M".
    // Ports ReInit_M + MarkAns_M from EL_M.js.
    //   correct_ans (EnteredCorrectAnswer) = LHSOrder from ChkAns_M, "~"-separated
    //   wrong_ans   (EnteredWrongAnswer)   = RHSOrder from ChkAns_M, "~"-separated
    //   opt_order   (ShuffledOptionsOrder) = "LHSOrder~RHSOrder" comma-separated,
    //                used by ReInit_M to restore the shuffled visual layout.
    //   both empty = skipped
    if (qd.qn_catg === "M" && qd.qn_html) {
      try {
        dispatch({
          type: "SET_QN_HTML_OVERRIDE",
          payload: injectTypeM(
            qd.qn_html,
            qd.correct_ans ?? "",   // EnteredCorrectAnswer (LHSOrder)
            qd.wrong_ans ?? "",   // EnteredWrongAnswer   (RHSOrder)
            qd.opt_order ?? "",   // ShuffledOptionsOrder for ReInit_M
          ),
        });
      } catch (err) { console.error("injectTypeM error:", err); }
    }

    // Extract correct answer for display
    window.setTimeout(() => {
      try {
        const frameDoc = iframe.contentDocument;
        const frameWin = iframe.contentWindow;
        if (!frameDoc || !state.showWrongAns) return;
        const extracted = extractCorrectAnswerFromIframe(frameDoc, frameWin, qd.qn_catg);
        if (extracted) dispatch({ type: "SET_ORIGINAL_ANSWER", payload: extracted });
      } catch { /* ignore */ }
    }, 500);

    resizeIframe();
  }, [state.current, state.showWrongAns, resizeIframe]);

  // ── postMessage listener ──────────────────────────────────────────────────
  useEffect(() => {
    const handler = (evt: MessageEvent) => {
      if (!evt.data || typeof evt.data !== "object") return;
      const { type: t, result, entered, correct } = evt.data as Record<string, string>;
      if (t === "MD_ANS_UPDATE") dispatch({ type: "CHECK_RESULT", payload: result ?? "Unknown" });
      if (t === "MD_REVIEW_DATA") dispatch({ type: "SET_REVIEW_ANSWERS", entered: entered ?? "", correct: correct ?? "" });
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  // ── Search ────────────────────────────────────────────────────────────────
  const handleSearch = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const params = new URLSearchParams({
        country: state.selectedCountry, yr: state.selectedYear,
        strand: state.strand, substrand: state.substrand,
        topic: state.topic, qn_type: state.qnType,
      });
      const data = await apiFetch<{ questions: QuestionStub[]; total: number; current_question: QuestionData; warning?: string }>(`${API_BASE_URL}api/search/EC?${params}`);
      if (data.warning || !data.total) {
        dispatch({ type: "SET_WARNING", payload: data.warning ?? "No records found" });
        return;
      }
      dispatch({ type: "SET_SEARCH_RESULT", questions: data.questions, current: data.current_question });
    } catch (e) { dispatch({ type: "SET_WARNING", payload: String(e) }); }
  };

  // ── Navigation ────────────────────────────────────────────────────────────
  const navigateTo = async (index: number) => {
    if (index < 0 || index >= state.questions.length) return;
    dispatch({ type: "SET_LOADING", payload: true });
    const q = state.questions[index];
    try {
      let url: string;
      if (state.isReportMode) {
        const p = new URLSearchParams({
          strand: String(q.strand), substrand: String(q.substrand),
          yr: String(q.yr), topic: String(q.topic), qn_no: String(q.qn_no),
          country: q.country, correct_ans: q.correct_ans ?? "",
          wrong_ans: q.wrong_ans ?? "", opt_order: q.opt_order ?? "",
          blank_ans: q.blank_ans ?? "", qn_info_index: String(q.qn_no),
        });
        url = `${API_BASE_URL}api/report/navigate/ec/?${p}`;
      } else {
        const p = new URLSearchParams({
          strand: String(q.strand), substrand: String(q.substrand),
          yr: String(q.yr), topic: String(q.topic), qn_no: String(q.qn_no), country: q.country,
        });
        url = `${API_BASE_URL}api/navigate/EC/?${p}`;
      }
      const data = await apiFetch<QuestionData>(url);
      dispatch({ type: "SET_CURRENT", current: data, index });
    } catch (e) { dispatch({ type: "SET_WARNING", payload: String(e) }); }
  };

  const dismissWarning = () => dispatch({ type: "SET_WARNING", payload: "" });

  const { current: qd } = state;

  // Fetch correct answer fallback
  useEffect(() => {
    if (!qd || !state.showWrongAns || !qd.qn_file_url) return;
    let cancelled = false;
    fetchCorrectAnswerFromQuestionFile(qd.qn_file_url, qd.qn_catg)
      .then(extracted => { if (!cancelled && extracted) dispatch({ type: "SET_ORIGINAL_ANSWER", payload: extracted }); })
      .catch(() => { /* ignore */ });
    return () => { cancelled = true; };
  }, [qd, state.showWrongAns]);

  // ── srcDoc builder ────────────────────────────────────────────────────────
  // F, N, W, M remove their own sidebar/interactive elements inside inject* functions.
  // For all other types, hide them in the initial skeleton render.
  const buildSrcDoc = (qd: QuestionData): string | undefined => {
    if (!qd.qn_html) return undefined;
    if (state.qnHtmlOverride) return state.qnHtmlOverride;
    // F, N, W, M: inject* handles removal — don't pre-hide
    if (qd.qn_catg === "F" || qd.qn_catg === "N" || qd.qn_catg === "W" || qd.qn_catg === "M") {
      return injectBaseCSS(qd.qn_html);
    }
    return injectBaseCSS(hideElementsByIdInHtml(qd.qn_html, ["KSD_DIVIDERBAR", "KSD_NUMPAD", "KSD_WORDS2FILLUP"]));
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <div style={{
        backgroundImage: `url(${popimg}), url(${popbg})`,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "left center, right center",
        backgroundSize: "30% 100%, 70% 100%",
        height: "16px", color: "white", padding: "7px 0px",
        fontWeight: "bold", fontSize: "12pt", fontFamily: "arial",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <span style={{ marginLeft: "10px" }}>Navigation Report</span>
        <img src={popclose} alt="close" height="30px" style={{ cursor: "pointer" }} onClick={() => window.close()} />
      </div>

      <div style={{ width: "100%", height: "100vh", overflow: "hidden", position: "relative", fontFamily: "Arial", fontSize: 11 }}>
        {state.loading && (
          <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(255,255,255,0.7)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Loading />
          </div>
        )}

        {state.warningMsg && (
          <div style={css.modalOverlay}>
            <div style={css.modal}>
              <p style={{ marginBottom: 0 }}>{state.warningMsg}</p>
              <button style={css.modalBtn} onClick={dismissWarning}>OK</button>
            </div>
          </div>
        )}

        <div ref={headerRef} style={{ backgroundImage: `url(${bg})`, backgroundRepeat: "repeat", width: "100%", boxSizing: "border-box" }}>
          {qd && (
            <div style={{ color: "white", fontSize: 16, paddingTop: 8, whiteSpace: "nowrap" }}>
              Yr:&nbsp;<CssLabel>{String(qd.year)}</CssLabel>&nbsp;&nbsp;
              Str:&nbsp;<CssLabel>{qd.strand_label}</CssLabel>&nbsp;&nbsp;
              SS:&nbsp;<CssLabel>{qd.substrand_label}</CssLabel>
            </div>
          )}
          {qd && (
            <div style={{ color: "black", fontSize: 16, paddingTop: 6, whiteSpace: "nowrap" }}>
              Top:&nbsp;<CssLabel>{qd.topic_label}</CssLabel>&nbsp;&nbsp;
              Lsn:&nbsp;<CssLabel>{qd.lesson_code}</CssLabel>&nbsp;&nbsp;
              QnNo:&nbsp;<CssLabel>{String(qd.qn_no)}</CssLabel>
            </div>
          )}
        </div>

        {qd ? (
          <div style={{ position: "relative", width: "100%" }}>
            <iframe
              ref={iframeRef}
              key={`${qd.qn_file_url}|${state.qnHtmlOverride ? "override" : qd.qn_html ? "srcdoc" : "src"}`}
              src={state.qnHtmlOverride || qd.qn_html ? undefined : qd.qn_file_url}
              srcDoc={buildSrcDoc(qd)}
              onLoad={handleIframeLoad}
              frameBorder={0}
              style={{ display: "block", width: "100%", border: "none", overflow: "auto" }}
              title="Question"
            />
            <VirtualNumpad visible={showNumpad} />
          </div>
        ) : (
          !state.loading && <div />
        )}
      </div>
    </>
  );
};

const CssLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span style={{
    backgroundColor: "yellow", fontWeight: "bold", fontSize: "14pt",
    color: "blue", fontFamily: "Calibri", paddingLeft: 5, paddingRight: 5,
  }}>
    {children}
  </span>
);

const css = {
  input: { border: "1px solid #003300", padding: "1px 3px", fontSize: 12 } as React.CSSProperties,
  btn: { padding: "2px 10px", cursor: "pointer", fontSize: 12 } as React.CSSProperties,
  modalOverlay: {
    position: "fixed" as const, inset: 0,
    backgroundColor: "rgba(0,0,0,0.45)", zIndex: 99999,
    display: "flex", alignItems: "center", justifyContent: "center",
  } as React.CSSProperties,
  modal: {
    backgroundColor: "white", padding: "24px 32px", borderRadius: 4,
    minWidth: 240, textAlign: "center" as const, fontFamily: "Arial",
    fontSize: 14, boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
  } as React.CSSProperties,
  modalBtn: { marginTop: 16, padding: "4px 24px", cursor: "pointer", fontSize: 13 } as React.CSSProperties,
};

export default EC_ViewQuestion;
export { };